import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';
import withTranslations from 'app/components/HOGs/withTranslations';
import userAPI from 'app/API/user.service.api';

const AliaslUserInput = ({ form, initialValue, placeholder, tr, ...props }) => {
  const hint = placeholder || tr['Your alias'];

  const validator = async (rule, value) => {
    if (value && value.length > 0) {
      return userAPI.checkAlias(value).then(
        (resp) => {
          if (resp.code !== 200) {
            throw new Error(resp.message);
          }
        },
        (err) => {
          throw new Error(err);
        }
      );
    }
    return false;
  };

  return (
    <Form.Item
      name="alias"
      initialValue={initialValue}
      rules={[
        {
          required: true,
          message: tr['Please input your unique alias'],
        },
        { validator },
      ]}
    >
      <Input {...props} placeholder={hint} />
    </Form.Item>
  );
};

AliaslUserInput.displayName = 'AliaslUserInput';
AliaslUserInput.propTypes = {
  form: PropTypes.object.isRequired,
  initialValue: PropTypes.string,
};

export default withTranslations(AliaslUserInput);
